'use client';
import { GroqImage } from '@/helpers/Image';
import { GROQButton, GROQImage } from '@/sanity/lib/definitions';
import { useIsMobile } from '@/hooks/useIsMobile';
import { richTextComponent } from '@/sanity/sanityPortableText';
import { motion } from 'framer-motion';
import { PortableText } from 'next-sanity';
import { PortableTextBlock } from 'sanity';
import ScrollVideoFramesCanvas from './ScrollVideoFramesCanvas';
import { CTAButton } from '@/shadcn/ui/button';

interface IFirstOrder {
  title: PortableTextBlock[];
  label1: string;
  label2: string; 
  ctaButton1: GROQButton;
  ctaButton2: GROQButton;
}

export default function FirstOrderSection({
  title,
  label1,
  label2,
  ctaButton1,
  ctaButton2,
}: IFirstOrder) {

  return (
    <section id="first-order-section" className="container flex flex-col lg:gap-[5rem] items-center justify-center lg:max-w-none pt-[4rem] lg:pt-[14.63rem] relative px-0">
      <ScrollVideoFramesCanvas
        basePath="/sales-page/watchFrame"
        startFrame={1}
        endFrame={50}
        scrollLengthRem={300}
        fit="contain"
      >
        <motion.div
          initial={{ opacity: 0, y: '-1rem' }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: [0.25, 1, 0.5, 1] }}
          className="flex relative w-full lg:w-auto flex-col gap-[4rem] lg:gap-[2.5rem] items-center justify-center mx-auto
          prose-headings:text-[6rem] lg:prose-headings:text-[9rem] prose-headings:text-white prose-headings:font-[300] prose-headings:uppercase prose-headings:leading-[120%] prose-headings:text-center prose-headings:px-0 lg:prose-headings:px-0"
        >
          <div className="flex flex-col lg:flex-row items-center gap-[2rem]">
            <span className="text-[#F2F0EF] text-[1.375rem] lg:text-[1.625rem] font-[300] tracking-[0.6rem] leading-none uppercase">
              {label1}
            </span>
            <div className="w-[7rem] h-[0.05rem] bg-[#F2F0EF]"/>
            <span className="text-[#F2F0EF] text-[1.375rem] lg:text-[1.625rem] font-[300] tracking-[0.6rem] leading-none uppercase">
              {label2}
            </span>
          </div>
          {title && (
            <PortableText value={title} components={richTextComponent} />
          )}
        </motion.div>
      </ScrollVideoFramesCanvas>
      <div className="hidden lg:flex flex-col lg:flex-row gap-[2rem]">
        <CTAButton data={ctaButton1} />
        <CTAButton data={ctaButton2} />
      </div>
    </section>
  );
}
